<template>
    <div>
        <article class="weui-article">
            <section class="logo-section">
                <img class="logo" src="../../../static/image/wxlogo.png">
            </section>
            <section class="watchword">
                <h2>专注校园快递，提供一站式综合服务平台。</h2>
            </section>
            <section>
                <section>
                    <h3>1.1 平台简介</h3>
                    <p>
                        校圆通校内一站式服务平台是校圆通（广州）科技发展有限公司基于学校学生各式各样的学习、生活需求深度抽象挖掘创建的一个综合性服务平台，平台专注学校相关领域，以打造网络时代新校园学习生活为宗旨，以为广大师生提供便利服务为行为准则，利用平台丰富的功能模块充分发挥平台作用，致力打造全国顶尖的校园服务平台。
                    </p>
                </section>
                <section>
                    <h3>1.2 服务内容</h3>
                    <p>
                        校圆通基于校园快递服务，利用校园快递服务这个用户切入口整合了包含校内跑腿服务、校园活动组织、校园新闻资讯，学生兼职信息发布，校园二手市场，校圆号等等功能。其中校内跑腿、学生兼职，校圆号这3个服务模块可用把学生空余时间利用起来，参与我们校圆平台为其他人提供服务，丰富学生校园生活的同时，能为他们创造收入，改善生活，更加有益学生的身心健康，让学生告别宅男宅女，枯燥无味的三点一线校园生活。我们还不定期组织举办校内文体活动，基于活动的有奖竞猜，增强平台和学生的互动，提高平台的亲和力和认同度。
                    </p>
                </section>
            </section>
        </article>

        <div class="weui-footer">
            <p class="weui-footer__links">
                <a href="javascript:void(0);" class="weui-footer__link">校圆通</a>
            </p>
            <p class="weui-footer__text">Copyright &copy; 2017-{{year}} aixyt.com</p>
        </div>
    </div>
</template>

<script>
import moment from "moment";

export default {
  data() {
    return {
        year: moment().format('YYYY')
    };
  }
};
</script>

<style scoped>
.logo-section {
    text-align: center;
    margin-top: 20px;
}
.logo {
    width: 50%;
  max-width: 120px;
}
.watchword {
    text-align: center;
    color: #1aad19;
}
.watchword h2 {
    font-weight: bold;
}
.weui-footer {
  margin-bottom: 20px;
  left: 0px;
  right: 0px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}
</style>





// WEBPACK FOOTER //
// src/components/infos/Introduction.vue